import Vue from 'vue';
import App from '@/App.vue';
import router from './router';
import store from '@/store/index';
import '@/common.js';

import '../../assets/iconfont/iconfont.css';
// import Vconsole from 'vconsole';
// let vConsole = new Vconsole();
// export default vConsole;

// new Vue({
//   router,
//   store,
//   render: h => h(App)
// }).$mount('#app');

setTimeout(() => {
  if (navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1) {
    console.log('该设备是安卓设备');
    // eslint-disable-next-line no-undef
    NodePlayer.activeAudioEngine(true);
  } else {
    console.log('除安卓以外的设备');
  }
  // eslint-disable-next-line no-undef
  NodePlayer.load(() => {
    new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app');
  });
}, 1000);
